import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=708d154d&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"
import style0 from "./Login.vue?vue&type=style&index=0&id=708d154d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../lianqiao-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708d154d",
  null
  
)

export default component.exports